import React from "react";
import styles from "./Login/Login.module.scss";
import { FormattedMessage } from "react-intl";
import { DownloadContent } from "./DownloadPopin";
import { LangSelection } from "./LangSelection";
import classNames from "classnames";
import { UserControlsHolder } from "@/components/ArtbookControls/UserControls";
export function DownloadPage() {
    return (React.createElement("div", { className: styles.loginPage },
        React.createElement("h2", { className: styles.header },
            React.createElement(FormattedMessage, { defaultMessage: "Digital artbook & soundtrack", id: "jCTuVI" }),
            React.createElement(UserControlsHolder, { className: styles.langPanel },
                React.createElement(LangSelection, null))),
        React.createElement("div", { className: classNames(styles.panel, styles.white) },
            React.createElement("p", { className: styles.subtitle },
                React.createElement(FormattedMessage, { defaultMessage: "Please connect to a PC device for full experience", id: "7fZWzx" })),
            React.createElement("div", { className: styles.downloadContent },
                React.createElement(DownloadContent, null)))));
}
